export default __webpack_public_path__ + "static/media/garde_corps_3.44a87816.png";